export default function applyToOneOrMany (fn, data) {
  if (data == null) {
    return data
  }

  if (Array.isArray(data)) {
    data = data.map(fn)
  } else {
    data = fn(data)
  }
  return data
}



// WEBPACK FOOTER //
// ./src/api/util/applyToOneOrMany.js